class ProductStandAddon extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-stand-toggle]');
    this.formInputs = this.querySelectorAll('[data-stand-form-input]');

    if (!this.toggle) return;

    this.toggle.addEventListener('change', () => {
      this.formInputs.forEach((input) => {
        input.disabled = !this.toggle.checked;
      });

      this.classList.toggle('is-selected', this.toggle.checked);
    });
  }
}

if (!customElements.get('product-stand-addon')) {
  customElements.define('product-stand-addon', ProductStandAddon);
}
